import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserLoginService } from '../../../services/user-login.service';
import { CognitoCallback } from '../../../services/cognito.service';
import { ApplicationDataService } from '../../../services/application.service';
import { ErrorService } from 'services/error.service';

@Component({
    selector: 'app-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
    email: string;


    constructor(public router: Router, public userService: UserLoginService, private applicationService: ApplicationDataService, private errorService: ErrorService) {
    }

    onSubmit() {
        this.applicationService.getCaseCorrectEmailForPasswordReset(this.email).subscribe(res => this.onEmailCheckResponse(res));
    }

    onEmailCheckResponse(caseCorrectEmail: string) {
        if (caseCorrectEmail) {
            this.userService.forgotPassword(caseCorrectEmail, this);
        }
        else {
            this.userService.forgotPassword(this.email, this);
        }
    }

    ngOnInit() {
    }

    cognitoCallback(message: string, result: any) {
        if (message == null && result == null) {
            this.router.navigate(['/forgot', this.email]);
        } else if (message == 'User password cannot be reset in the current state.') {
            this.errorService.showError("This account is awaiting activation, an email has been sent to you with further instructions.");
        } else {
            this.errorService.showError(message);
        }
    }

}

@Component({
    selector: 'app-forgot2',
    templateUrl: './forgot2.component.html',
    styleUrls: ['./forgot.component.css']
})
export class Forgot2Component implements CognitoCallback, OnInit, OnDestroy {
    verificationCode: string;
    email: string;
    Password: string;
    private sub: any;
    hide: boolean = true;

    constructor(public router: Router, public route: ActivatedRoute,
        public userService: UserLoginService, private applicationService: ApplicationDataService, private errorService: ErrorService) {
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.email = params['email'];

        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    onSubmit() {
        this.applicationService.getCaseCorrectEmail(this.email).subscribe(res => this.onEmailCheckResponse(res));

    }

    onEmailCheckResponse(caseCorrectEmail: string) {
        if (caseCorrectEmail) {
            this.userService.confirmNewPassword(caseCorrectEmail, this.verificationCode, this.Password, this);
        }
        else {
            this.userService.confirmNewPassword(this.email, this.verificationCode, this.Password, this);
        }
    }

    cognitoCallback(message: string) {
        if (message != null) {
            this.errorService.showError(message);
        } else {
            this.router.navigate(['public/login', this.email]);
        }
    }
}
